import { api } from '@/lib/api';
import type {
  InspectionExport,
  InspectionExportsResponse,
  ManagementReview,
  ManagementReviewInput,
  ManagementReviewsResponse,
  ValidationEvidence,
  ValidationEvidenceInput,
  ValidationRequirement,
  ValidationRequirementFilters,
  ValidationRequirementsResponse,
  ValidationSignature,
  ValidationSummary,
} from '../types/validation.types';

const BASE = '/v4/eqms-validation';

export function getValidationSummary(): Promise<ValidationSummary> {
  return api.get(`${BASE}/summary`);
}

export function getValidationRequirements(
  filters: ValidationRequirementFilters,
): Promise<ValidationRequirementsResponse> {
  return api.get(`${BASE}/requirements`, filters as unknown as Record<string, unknown>);
}

export function recordValidationEvidence(
  requirementId: string,
  input: ValidationEvidenceInput,
): Promise<{
  requirement: ValidationRequirement;
  evidence: ValidationEvidence;
  signature: ValidationSignature;
}> {
  return api.post(`${BASE}/requirements/${requirementId}/evidence`, input);
}

export function getManagementReviews(
  pageNumber = 0,
  pageLength = 25,
): Promise<ManagementReviewsResponse> {
  return api.get(`${BASE}/management-reviews`, { pageNumber, pageLength });
}

export function createManagementReview(
  input: ManagementReviewInput,
): Promise<{ review: ManagementReview; signature: ValidationSignature }> {
  return api.post(`${BASE}/management-reviews`, input);
}

export function getInspectionExports(): Promise<InspectionExportsResponse> {
  return api.get(`${BASE}/inspection-exports`);
}

export function createInspectionExport(): Promise<{ export: InspectionExport }> {
  return api.post(`${BASE}/inspection-exports`, { scope: 'full_eqms' });
}

export function getInspectionExport(id: string): Promise<{ export: InspectionExport }> {
  return api.get(`${BASE}/inspection-exports/${id}`);
}
